/**
 * Model class for agency entry validation
 */

import Api from '@/providers/Api'
import * as _ from 'lodash'

const statusOptions = {
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    PAUSED: 'Paused'
}

export default {
    // helper method to populate agency options for other models
    async loadAgencyOptions (modelField) {
        const agencies = await Api.getAllItems(null, 'agency')
        modelField.options = _.map(agencies, (agency) => {
            return {
                value: agency.id, text: agency.name
            }
        })
    },
    async getAgencyName (agency_id) {
        const agency = await Api.getItem({}, 'agency', agency_id)
        return agency.name
    },
    getStatusLabel (value) {
        return statusOptions[value]
    },
    fields: {
        name: {
            label: 'Name',
            type: 'text'
        },
        abbreviation: {
            label: 'Abbreviation',
            type: 'text'
        },
        status: {
            label: 'Status',
            type: 'select',
            options: statusOptions
        },
        progAdminUsers: {
            label: 'Program Administrators',
            type: 'multiselect',
            multiselectOptions: {
                placeholder: 'Type email address to search',
                label: 'full_name_and_email',
                multiple: true,
            },
            async doSearch (query) {
                return Api.getItems(this, 'user', { email: { field: 'email', value: query } })
            },
        },
        ownerRepUsers: {
            label: 'Owner\'s Representatives',
            type: 'multiselect',
            multiselectOptions: {
                placeholder: 'Type email address to search',
                label: 'full_name_and_email',
                multiple: true,
            },
            async doSearch (query) {
                return Api.getItems(this, 'user', { email: { field: 'email', value: query } })
            },
        },
        projectManagerUsers: {
            label: 'Project Managers',
            type: 'multiselect',
            multiselectOptions: {
                placeholder: 'Type email address to search',
                label: 'full_name_and_email',
                multiple: true,
            },
            async doSearch (query) {
                return Api.getItems(this, 'user', { email: { field: 'email', value: query } })
            },
        },
    }
}
